"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CademyLimits = void 0;
const Limits_1 = require("../Domain/Limits");
exports.CademyLimits = Limits_1.Limits.create({
    numberOfAdmins: {
        name: 'Number of Admins',
        description: 'Admin limit for an Educator',
        unit: 'admins',
    },
    numberOfCourseInvites: {
        name: 'Number of Course Invites',
        description: 'Maximum number of contacts that can be invited to a course at once',
        unit: 'admins',
    },
    numberOfImportedBookings: {
        name: 'Number of Imported Bookings',
        description: 'Maximum number of bookings that can be imported to a course at once',
        unit: 'bookings',
    },
    numberOfImportedOrders: {
        name: 'Number of Imported Orders',
        description: 'Maximum number of orders that can be imported to a course at once',
        unit: 'orders',
    },
    numberOfPublishedCourses: {
        name: 'Number of published Courses',
        description: 'Maximum number of courses that can be published at the same time',
        unit: 'courses',
    },
    maxFileUploadSize: {
        name: 'Max File Upload Size',
        description: 'Maximum file size that can be uploaded',
        unit: 'MB',
    },
    maxAgeOfForumPosts: {
        name: 'Max Age of Forum Posts',
        description: 'Maximum time a forum post can be viewed for',
        unit: 'days',
    },
});
